/**
 * Page zoom for the View menu.
 *
 * Tailwind sizes almost everything in rem, so scaling the root font size scales the
 * whole interface - text, padding, row heights - rather than only the text. That is
 * why this changes documentElement.style.fontSize instead of the CSS `zoom` property,
 * which Firefox only learned recently and which blurs fixed-position layers.
 *
 * The choice is remembered per browser, because someone who needs larger type needs it
 * on every visit, not once.
 */
const KEY = 'mrp_zoom';
const BASE_PX = 16;
const MIN = 0.8;
const MAX = 1.4;
const STEP = 0.1;

const clamp = (v) => Math.min(MAX, Math.max(MIN, Math.round(v * 100) / 100));

export function getZoom() {
  try {
    const v = parseFloat(localStorage.getItem(KEY));
    return Number.isFinite(v) ? clamp(v) : 1;
  } catch {
    return 1; // private window, or storage blocked
  }
}

export function applyZoom(scale) {
  const z = clamp(scale);
  document.documentElement.style.fontSize = z === 1 ? '' : `${BASE_PX * z}px`;
  try { localStorage.setItem(KEY, String(z)); } catch { /* nothing to do */ }
  return z;
}

export const zoomIn = () => applyZoom(getZoom() + STEP);
export const zoomOut = () => applyZoom(getZoom() - STEP);
export const resetZoom = () => applyZoom(1);

/** Called once at startup so a remembered choice survives a reload. */
export function restoreZoom() {
  const z = getZoom();
  if (z !== 1) applyZoom(z);
}
